import { LogPayload } from '@ads-bread/shared/bread/codecs';
import { generateShortLivedToken } from '@ads-bread/shared/bread/util';
import { LoggerClient } from './client';

interface CreateSplunkLoggerConfig {
  eventCollectorLogSecret?: string;
}

let sendLog: (logPayload: LogPayload) => void;

/**
 * Creates a Splunk HTTP Event Collector logger for the browser
 * @param CreateSplunkLoggerConfig
 * @returns LoggerClient
 */
export const createSplunkLogger = ({
  eventCollectorLogSecret,
}: CreateSplunkLoggerConfig): LoggerClient | undefined => {
  if (!sendLog) {
    sendLog = getSplunkLogger(eventCollectorLogSecret || '');
  }

  const splunkLogger: LoggerClient = {
    error: (msg, context) => {
      sendLog({
        level: 'error',
        message: msg,
        context: context || {},
      });
    },
    info: (msg, context) => {
      sendLog({
        level: 'info',
        message: msg,
        context: context || {},
      });
    },
    warn: (msg, context) => {
      sendLog({
        level: 'warn',
        message: msg,
        context: context || {},
      });
    },
    debug: (msg, context) => {
      sendLog({
        level: 'debug',
        message: msg,
        context: context || {},
      });
    },
  };

  return splunkLogger;
};

/**
 * Creates a Splunk HTTP Event Collector logger for the browser
 * @param eventCollectorLogSecret
 * @returns (logPayload: LogPayload) => void
 */
export const getSplunkLogger = (
  eventCollectorLogSecret: string
): ((logPayload: LogPayload) => void) => {
  return (logPayload: LogPayload) => {
    const token = generateShortLivedToken(eventCollectorLogSecret);
    navigator?.sendBeacon?.(`/log?token=${token}`, JSON.stringify(logPayload));
  };
};
